<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="主键" prop="pid">
        <el-input
          v-model="queryParams.pid"
          placeholder="请输入主键"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="租户" prop="tenantId">
        <el-input
          v-model="queryParams.tenantId"
          placeholder="请输入租户"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="标书编号" prop="bidNumber">
        <el-input
          v-model="queryParams.bidNumber"
          placeholder="请输入标书编号"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="标书名称" prop="bidName">
        <el-input
          v-model="queryParams.bidName"
          placeholder="请输入标书名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="标书计划页数" prop="planPageSize">
        <el-input
          v-model="queryParams.planPageSize"
          placeholder="请输入标书计划页数"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="标书计划字数" prop="planFontLength">
        <el-input
          v-model="queryParams.planFontLength"
          placeholder="请输入标书计划字数"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="评分自测分数" prop="selfAssessmentScore">
        <el-input
          v-model="queryParams.selfAssessmentScore"
          placeholder="请输入评分自测分数"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="风险评估项目数量" prop="riskAssessmentNumber">
        <el-input
          v-model="queryParams.riskAssessmentNumber"
          placeholder="请输入风险评估项目数量"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="版本号" prop="version">
        <el-input
          v-model="queryParams.version"
          placeholder="请输入版本号"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          v-hasPermi="['biddingdocument:bid:add']"
        >新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="success"
          plain
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
          v-hasPermi="['biddingdocument:bid:edit']"
        >修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['biddingdocument:bid:remove']"
        >删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['biddingdocument:bid:export']"
        >导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="bidList" @selection-change="handleSelectionChange"  border max-height="650">
      <el-table-column type="selection" width="40" align="center" />
      <el-table-column label="主键" align="center" prop="pid" />
      <el-table-column label="租户" align="center" prop="tenantId" />
      <el-table-column label="标书编号" align="center" prop="bidNumber" />
      <el-table-column label="标书名称" align="center" prop="bidName" />
      <el-table-column label="标书类型" align="center" prop="bidType" />
      <el-table-column label="招标要求" align="center" prop="biddingRequirements" />
      <el-table-column label="评分标准" align="center" prop="gradingCriteria" />
      <el-table-column label="风险评估项" align="center" prop="riskAssessmentItems" />
      <el-table-column label="标书目录" align="center" prop="bidTableContents" />
      <el-table-column label="标书大纲" align="center" prop="bidOutline" />
      <el-table-column label="标书计划页数" align="center" prop="planPageSize" />
      <el-table-column label="标书计划字数" align="center" prop="planFontLength" />
      <el-table-column label="评分自测状态" align="center" prop="selfAssessmentStatus" />
      <el-table-column label="评分自测分数" align="center" prop="selfAssessmentScore" />
      <el-table-column label="风险评估状态" align="center" prop="riskAssessmentStatus" />
      <el-table-column label="风险评估项目数量" align="center" prop="riskAssessmentNumber" />
      <el-table-column label="版本号" align="center" prop="version" />
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['biddingdocument:bid:edit']"
          >修改</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            v-hasPermi="['biddingdocument:bid:remove']"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改标书对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="主键" prop="pid">
          <el-input v-model="form.pid" placeholder="请输入主键" />
        </el-form-item>
        <el-form-item label="租户" prop="tenantId">
          <el-input v-model="form.tenantId" placeholder="请输入租户" />
        </el-form-item>
        <el-form-item label="标书编号" prop="bidNumber">
          <el-input v-model="form.bidNumber" placeholder="请输入标书编号" />
        </el-form-item>
        <el-form-item label="标书名称" prop="bidName">
          <el-input v-model="form.bidName" placeholder="请输入标书名称" />
        </el-form-item>
        <el-form-item label="招标要求" prop="biddingRequirements">
          <el-input v-model="form.biddingRequirements" type="textarea" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="评分标准" prop="gradingCriteria">
          <el-input v-model="form.gradingCriteria" type="textarea" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="风险评估项" prop="riskAssessmentItems">
          <el-input v-model="form.riskAssessmentItems" type="textarea" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="标书目录" prop="bidTableContents">
          <el-input v-model="form.bidTableContents" type="textarea" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="标书大纲" prop="bidOutline">
          <el-input v-model="form.bidOutline" type="textarea" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item label="标书计划页数" prop="planPageSize">
          <el-input v-model="form.planPageSize" placeholder="请输入标书计划页数" />
        </el-form-item>
        <el-form-item label="标书计划字数" prop="planFontLength">
          <el-input v-model="form.planFontLength" placeholder="请输入标书计划字数" />
        </el-form-item>
        <el-form-item label="评分自测分数" prop="selfAssessmentScore">
          <el-input v-model="form.selfAssessmentScore" placeholder="请输入评分自测分数" />
        </el-form-item>
        <el-form-item label="风险评估项目数量" prop="riskAssessmentNumber">
          <el-input v-model="form.riskAssessmentNumber" placeholder="请输入风险评估项目数量" />
        </el-form-item>
        <el-form-item label="版本号" prop="version">
          <el-input v-model="form.version" placeholder="请输入版本号" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listBid, getBid, delBid, addBid, updateBid } from "@/api/biddingdocument/bid";

export default {
  name: "Bid",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 标书表格数据
      bidList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pid: null,
        tenantId: null,
        bidNumber: null,
        bidName: null,
        bidType: null,
        biddingRequirements: null,
        gradingCriteria: null,
        riskAssessmentItems: null,
        bidTableContents: null,
        bidOutline: null,
        planPageSize: null,
        planFontLength: null,
        selfAssessmentStatus: null,
        selfAssessmentScore: null,
        riskAssessmentStatus: null,
        riskAssessmentNumber: null,
        version: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询标书列表 */
    getList() {
      this.loading = true;
      listBid(this.queryParams).then(response => {
        this.bidList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        pid: null,
        tenantId: null,
        bidNumber: null,
        bidName: null,
        bidType: null,
        biddingRequirements: null,
        gradingCriteria: null,
        riskAssessmentItems: null,
        bidTableContents: null,
        bidOutline: null,
        planPageSize: null,
        planFontLength: null,
        selfAssessmentStatus: null,
        selfAssessmentScore: null,
        riskAssessmentStatus: null,
        riskAssessmentNumber: null,
        version: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.pid)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加标书";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const pid = row.pid || this.ids
      getBid(pid).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改标书";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.pid != null) {
            updateBid(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addBid(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const pids = row.pid || this.ids;
      this.$modal.confirm('是否确认删除标书编号为"' + pids + '"的数据项？').then(function() {
        return delBid(pids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('biddingdocument/bid/export', {
        ...this.queryParams
      }, `bid_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
